import { B10_FORM_INITIAL_VALUES as B10_FORM_INITIAL_VALUES_SHARED } from 'shared'

export const B10_FORM_INITIAL_VALUES = B10_FORM_INITIAL_VALUES_SHARED

export const B10NavOptions = [
  {
    label: 'a) napojení staveniště na stávající dopravní a technickou infrastrukturu',
    target: 'b10.traficAndtechnicalInfrastructureConnection',
  },
  {
    label: 'b) ochrana okolí staveniště a požadavky na související asanace, ...',
    target: 'b10.protectionOfSurroundings',
  },
  {
    label: 'c) vstup a vjezd na stavbu, přístup na stavbu po dobu výstavby, ...',
    target: 'b10.constructionEntrance',
  },
  {
    label: 'd) maximální dočasné a trvalé zábory pro staveniště',
    target: 'b10.maximumLandOccupation',
  },
  {
    label: 'e) požadavky na ochranu životního prostředí při výstavbě ...',
    target: 'b10.environmentProtection',
  },
  {
    label: 'f) zásady bezpečnosti a ochrany zdraví při práci na staveništi',
    target: 'b10.OHS',
  },
  {
    label: 'g) bilance zemních prací, požadavky na přísun nebo deponie zemin',
    target: 'b10.earthWorks',
  },
  {
    label: 'h) limity pro užití výškové mechanizace',
    target: 'b10.heightMachineryLimits',
  },
  {
    label: 'i) požadavky na postupné uvádění stavby do provozu (užívání), ...',
    target: 'b10.requirements',
  },
  {
    label: 'j) návrh fází výstavby za účelem provedení kontrolních prohlídek',
    target: 'b10.constructionPhases',
  },
  {
    label: 'k) dočasné objekty',
    target: 'b10.temporaryObjects',
  },
]
